export const getSortDirection = (dir) => {
    // console.log('getSortDirection',dir);
    if(dir && dir === 'ascend') {
        return 'asc'
    } else if(dir && dir === 'descend'){
        return 'desc'
    }
    return null
} 